import { EntidadeBase } from 'hay-core-react';
// SMS não pode conter quebra de linha nem caracteres escapados com barra (ex.: "\n" digitado
// literalmente, ou colado de um texto que já veio com escapes) — normalizado aqui antes de
// salvar, para o conteúdo já chegar limpo no backend.
function sanitizarMensagem(mensagem) {
    if (!mensagem) return mensagem;
    return mensagem.replace(/[\r\n]+/g, ' ').replace(/\\/g, '');
}

class SmsEnvioModel extends EntidadeBase {
    constructor() { super('smsenvio'); }

    async create(model) {
        if (model.mensagem) model.mensagem.value = sanitizarMensagem(model.mensagem.value);
        return super.create(model);
    }

    async update(model) {
        if (model.mensagem) model.mensagem.value = sanitizarMensagem(model.mensagem.value);
        return super.update(model);
    }
}

const instance = new SmsEnvioModel();
export default instance;
